import { z } from 'zod'

import type {
  CommonResponseInteger,
  CommonResponseListProblemResponse,
  CommonResponseWorksheetCreationFilterResponse,
  CommonResponseWorksheetDetailResponse,
  ProblemResponse,
  WorksheetFilterCreationResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type MakeWorksheetProblem,
  MakeWorksheetProblemSchema,
  type WorksheetDetail,
  WorksheetDetailSchema,
  type WorksheetFilterDraft,
  WorksheetFilterDraftSchema,
  type WorksheetFilterId,
  WorksheetFilterIdSchema,
} from './schemas'

const ENTITY = 'MakeWorksheet'

// 스펙이 실제 응답과 다른 곳. 2026-10-08 백엔드 origin/develop(08ff3525b) 의 worksheet/controller/response/ 로 확인.
//   1. 필터(`/worksheet/filter`, 학습지 상세의 filter) — 서버는 sealed 클래스의 하위 클래스를 그대로 직렬화하고
//      type 필드로만 가르는데(@JsonTypeInfo 없음) 스펙은 `object | null` 로 뭉갰다(WorksheetCreationFilterResponse.kt).
//      필터에 실리는 나의DB 문항(MyDbProblemDetailWithLatestVersionResponse)도 그래서 스펙에 없다
//   2. Kotlin nullable 이 스펙에 optional 로만 그려졌는데 null 이 온다 — 문제의 problemSource(ProblemResponse.kt),
//      PDF 의 designTemplateId·pdfDate(WorksheetPdfResponse.kt)
// 스키마가 실제 모양을 검증하므로 입력은 생성 타입으로 받고 이 한 줄에서만 unknown 을 거친다.
const asWire = (raw: unknown): unknown => raw

export const adaptWorksheetFilterId = (
  raw: WorksheetFilterCreationResponse | undefined,
): WorksheetFilterId =>
  parseApiResponse(z.object({ filterId: WorksheetFilterIdSchema }), raw, ENTITY)?.filterId

export const adaptWorksheetFilterDraft = (
  raw: CommonResponseWorksheetCreationFilterResponse['data'],
): WorksheetFilterDraft => parseApiResponse(WorksheetFilterDraftSchema, asWire(raw), ENTITY)

export const adaptMakeWorksheetProblems = (
  raw: CommonResponseListProblemResponse['data'] | ProblemResponse[],
): MakeWorksheetProblem[] =>
  parseApiResponse(z.array(MakeWorksheetProblemSchema), asWire(raw), ENTITY)

export const adaptRecommendedProblemCount = (raw: CommonResponseInteger['data']): number =>
  parseApiResponse(z.number(), raw, ENTITY)

export const adaptCreatedWorksheetId = (
  raw: CommonResponseInteger['data'],
): WorksheetDetail['id'] => parseApiResponse(WorksheetDetailSchema.shape.id, raw, ENTITY)

export const adaptWorksheetDetail = (
  raw: CommonResponseWorksheetDetailResponse['data'],
): WorksheetDetail => parseApiResponse(WorksheetDetailSchema, asWire(raw), ENTITY)
